import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import dayjs from 'dayjs';
import { useEffect, useState } from 'react';
import { isEmpty, sortObject } from 'src/common/helper';
import BtnGradient from 'src/components/common/button/BtnGradient';
import BtnOutlineGradient from 'src/components/common/button/BtnOutlineGradient';
// import { useNotify } from 'src/context/ContextNotify';
import { getAPI, postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import GenerateField from './GenerateField';


type DialogFormType = {
  open: boolean;
  handleClose: () => void;
  submission_id: string;
  patientid: string | null;
  handleConfirm: () => void;
  handleError: (msg: string) => void;
};

const DialogForm: React.FC<DialogFormType> = (props) => {
  // const notifyContext = useNotify();
  const [answerDetail, setAnswerDetail] = useState<any>(null);

  useEffect(() => {
    const token = getToken();

    if (!token) {
      throw new Error('Failed to get access token');
    }
    if (props.submission_id) {
      getAPI(`/staff/answers-with-latest-questionnaire/${props.submission_id}?token=${token}`)
        .then((res) => {
          if (res.code === 200) {
            setAnswerDetail(res.data);
          }
        })
        .finally(() => {});
    } else {
      getAPI(
        `/staff/latest-questionnaire?patient_id=${props.patientid}&token=${token}`
      )
        .then((res) => {
          if (res.code === 200) {
            if (
              (Array.isArray(res.data.answers) &&
                res.data.answers.length === 0) ||
              !res.data.answers
            ) {
              const answers = res.data.metadata.fields.reduce(
                (result: any, field: any) => {
                  result[field.field_id] = '';
                  return result;
                },
                {}
              );
              setAnswerDetail({ ...res.data, answers: answers });
            } else {
              setAnswerDetail(res.data);
            }
          }
        })
        .finally(() => {});
    }
  }, [props.submission_id, props.patientid]);

  const validate = () => {
    let keyError = '';
    answerDetail.metadata?.fields?.map((field: any) => {
      switch (field.type) {
        case 'text':
          if (
            field.required &&
            isEmpty(answerDetail.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            (field.min_length &&
              answerDetail.answers[field.field_id]?.value &&
              answerDetail.answers[field.field_id]?.value.length <
                field.min_length) ||
            (field.max_length &&
              answerDetail.answers[field.field_id]?.value &&
              answerDetail.answers[field.field_id]?.value.length >
                field.max_length)
          ) {
            keyError = `${field.label} 最小文字数 ${field.min_length}, 最大文字数 ${field.max_length}`;
          }
          break;
        case 'textarea':
          if (
            field.required &&
            isEmpty(answerDetail.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            (field.min_length &&
              answerDetail.answers[field.field_id]?.value &&
              answerDetail.answers[field.field_id]?.value.length <
                field.min_length) ||
            (field.max_length &&
              answerDetail.answers[field.field_id]?.value &&
              answerDetail.answers[field.field_id]?.value.length >
                field.max_length)
          ) {
            keyError = `${field.label} 最小文字数 ${field.min_length}, 最大文字数 ${field.max_length}`;
          }
          break;
        case 'checkbox':
          if (
            field.required &&
            !Array.isArray(answerDetail.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            field.required &&
            answerDetail.answers[field.field_id]?.value.length === 0
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            (field.min_selection &&
              answerDetail.answers[field.field_id]?.value.length <
                field.min_selection) ||
            (field.max_selection &&
              answerDetail.answers[field.field_id]?.value.length >
                field.max_selection)
          ) {
            keyError = `${field.label} 最小 ${field.min_selection}, 最大 ${field.max_selection}`;
          }
          break;
        case 'radio':
          if (
            field.required &&
            isEmpty(answerDetail.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          }
          break;
        case 'date':
          if (
            field.required &&
            isEmpty(answerDetail.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            dayjs(answerDetail.answers[field.field_id]?.value)
              ?.format('YYYY/MM/DD')
              .toString() === 'Invalid Date'
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            field.min_date &&
            dayjs(field.min_date) >
              dayjs(answerDetail.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label} 最小日付 ${field.min_date}`;
          } else if (
            field.max_date &&
            dayjs(field.max_date) <
              dayjs(answerDetail.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label} 最大日付 ${field.max_date}`;
          }
          break;
        case 'time':
          if (
            field.required &&
            isEmpty(answerDetail.answers[field.field_id]?.value)
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            dayjs(
              `${dayjs().format('YYYY-MM-DD')} ${
                answerDetail.answers[field.field_id]?.value
              }`
            )
              ?.format('YYYY/MM/DD')
              .toString() === 'Invalid Date'
          ) {
            keyError = `${field.label}を入力してください`;
          } else if (
            field.min_time &&
            dayjs(`${dayjs().format('YYYY-MM-DD')} ${field.min_time}`) >
              dayjs(
                `${dayjs().format('YYYY-MM-DD')} ${
                  answerDetail.answers[field.field_id]?.value
                }`
              )
          ) {
            keyError = `${field.label} 最小時間 ${field.min_time}`;
          } else if (
            field.max_time &&
            dayjs(`${dayjs().format('YYYY-MM-DD')} ${field.max_time}`) <
              dayjs(
                `${dayjs().format('YYYY-MM-DD')} ${
                  answerDetail.answers[field.field_id]?.value
                }`
              )
          ) {
            keyError = `${field.label} 最大時間 ${field.max_time}`;
          }
          break;
        default:
          break;
      }
      return field;
    });
    // check validate その他
    if (!keyError) {
      for (const key in answerDetail.answers) {
        const answer = answerDetail.answers[key];
        
        // Check array values
        if (answer?.value && Array.isArray(answer.value)) {
          for (const value of answer.value) {
            if (typeof value === 'string' && value.includes('その他')) {
              // Check if その他 has content in parentheses
              if (value === 'その他' || !value.includes('（') || !value.includes('）')) {
                keyError = `その他を入力してください`;
              }
              
              // Check if there's actual content between parentheses
              const otherInputValue = value.substring(4, value.length - 1);
              if (otherInputValue.trim() === '') {
                keyError = `その他を入力してください`;
              }
            }
          }
        }

        if (answer?.children_answers && typeof answer.children_answers === 'object') {
          for (const childKey in answer.children_answers) {
            const childAnswer = answer.children_answers[childKey];
            if (Array.isArray(childAnswer.value)) {
              for (const value of childAnswer.value) {
                if (typeof value === 'string' && value.includes('その他')) {
                  const otherMoreValue = childAnswer.value.find(
                    (item: string) => item.startsWith('other_more_information: ')
                  );
                  if (otherMoreValue) {
                    // Extract the content after 'other_more_information: '
                    const otherMoreInputValue = otherMoreValue.substring('other_more_information: '.length)
                    if (otherMoreInputValue.trim() === '') {
                      keyError = `その他を入力してください`;
                    }
                  } else {
                    // Check if その他 has content in parentheses
                    if (value === 'その他' || !value.includes('（') || !value.includes('）')) {
                      keyError = `その他を入力してください`;
                    }
                    // Check if there's actual content between parentheses
                    const otherInputValue = value.substring(4, value.length - 1);
                    if (otherInputValue.trim() === '') {
                      keyError = `その他を入力してください`;
                    }
                  }
                }
              }
            }
            if (Array.isArray(childAnswer.dependent_answers)) {
              for (const value of childAnswer.dependent_answers) {
                if (typeof value === 'string' && value.includes('その他')) {
                  // Check if その他 has content in parentheses
                  if (value === 'その他' || !value.includes('（') || !value.includes('）')) {
                    keyError = `その他を入力してください`;
                  }
                  // Check if there's actual content between parentheses
                  const otherInputValue = value.substring(4, value.length - 1);
                  if (otherInputValue.trim() === '') {
                    keyError = `その他を入力してください`;
                  }
                }
              }
            }
          }
        }
      };
    }

    if (keyError) {
      props.handleError(keyError || 'Failed to post data');
      return false;
    }

    // notifyContext.setNotifyMessage({
    //   show: false,
    //   message: '',
    //   type: 'error',
    // });

    return true;
  };

  const handleSubmit = () => {
    try {
      if (!validate()) {
        return;
      }

      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      postAPI(`/staff/answers?token=${token}`, { ...answerDetail, user_id: 1 })
        .then((res: any) => {
          if (res.code === 200) {
            // notifyContext.setNotifyMessage({
            //   show: true,
            //   message: Questionaire.SaveSuccess,
            //   type: 'success',
            // });
            props.handleConfirm();
          } else {
            // notifyContext.setNotifyMessage({
            //   show: true,
            //   message: res.msg || 'Failed to post data',
            //   type: 'error',
            // });
            props.handleError(res.msg || 'Failed to post data');
          }
        })
        .finally(() => {});
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  const handleChangeValue = (name: string, value: any) => {
    const temp = { ...answerDetail.answers };
    temp[name] = value;
    setAnswerDetail((prev: any) => ({
      ...prev,
      answers: { ...temp },
    }));
  };

  return (
    <Dialog
      open={props.open}
      onClose={props.handleClose}
      aria-labelledby='alert-dialog-title'
      aria-describedby='alert-dialog-description'
      sx={{ '& .MuiDialog-paper': { width: '100%', maxWidth: '750px' } }}
    >
      <DialogTitle id='scroll-dialog-title'>
        <Stack
          direction={'row'}
          justifyContent={'space-between'}
          alignItems={'center'}
        >
          <Typography fontSize={'20px'} fontWeight={500}>
            WEB問診票編集
          </Typography>
          <IconButton
            aria-label='toggle password visibility'
            edge='end'
            onClick={props.handleClose}
          >
            <Box
              component={'img'}
              src='/images/ic-close.svg'
              alt='icon eye'
              sx={{ width: '24px', height: '24px' }}
            />
          </IconButton>
        </Stack>
      </DialogTitle>
      <DialogContent sx={{ width: {xs: '100%', sm: '750px'} }}>
        {Array.isArray(answerDetail?.metadata?.fields) &&
          sortObject(answerDetail?.metadata.fields).map(
            (field: any, index: number) => {
              return (
                <GenerateField
                  field={field}
                  key={index}
                  answer={
                    answerDetail?.answers
                      ? answerDetail?.answers[field.field_id]
                      : null
                  }
                  handleChangeValue={handleChangeValue}
                  isEdit={false}
                  staffEdit={true}
                />
              );
            }
          )}
        <Stack alignItems={'center'}>
          <Typography></Typography>
        </Stack>
      </DialogContent>
      <DialogActions sx={{ p: '20px' }}>
        <BtnOutlineGradient
          text='キャンセル'
          handleButtonClick={props.handleClose}
        />
        <BtnGradient text='保存' handleButtonClick={handleSubmit} />
      </DialogActions>
    </Dialog>
  );
};

export default DialogForm;
